import type { LoadStatus } from '@stores/viewerStore';
import { ApiError, isHttpError } from '@utils/http';
import { createLogger } from '@utils/logger';
import { enterPrivateAccessDeniedState, isAccessDenied } from './permissions';

const log = createLogger('SceneSession');

export const NETWORK_OFFLINE_MESSAGE =
  'Network disconnected. Please check your connection and retry.';

// ---------------------------------------------------------------------------
// 错误分类
// ---------------------------------------------------------------------------

/** 后端业务/HTTP 错误是否为「未找到」。 */
export function isSceneNotFound(err: unknown): boolean {
  if (isHttpError(err, 404)) return true;
  if (err instanceof ApiError) {
    if (err.code === 404) return true;
    if (err.code === -1 && /not\s*exist|does\s*not\s*exist/i.test(err.message)) return true;
  }
  return false;
}

// ---------------------------------------------------------------------------
// 统一错误处理
// ---------------------------------------------------------------------------

export function handleLoadError(
  err: unknown,
  setStatus: (status: LoadStatus, msg?: string) => void,
  setLoadProgress: (p: number | null) => void,
): void {
  if (isSceneNotFound(err)) {
    log.warn('Scene not found', err);
    setStatus('not-found');
  } else if (isAccessDenied(err)) {
    log.warn('Access denied', err);
    enterPrivateAccessDeniedState();
  } else {
    const msg = !navigator.onLine
      ? NETWORK_OFFLINE_MESSAGE
      : err instanceof Error
        ? err.message
        : 'Unknown error';
    log.error('Failed to load scene', err);
    setStatus('error', msg);
  }
  setLoadProgress(null);
}
